module.exports = __webpack_public_path__ + "img/menu_4.9dd361bb.png";